import type FeatureFlagsService from 'garaje/services/feature-flags';
import type StateService from 'garaje/services/state';
import { isBillingFeatureEnabled } from 'garaje/utils/billing-features';

/**
 * True when the current scope should get the v2 Threat intelligence surface (the emno-fe iframe)
 * rather than the pre-v2 RRC dashboard.
 *
 * Composite of three checks:
 *   1. `emno-threat-intelligence-web-v2` Split — rollout gate for the v2 app itself,
 *   2. `threat_dashboard` billing entitlement — paid-tier access from the billing REST features
 *      endpoint (read via `state.features?.features`, scope-aware and MPB-aware),
 *   3. `emno-threat-intelligence-vr-ent-limited` Split — fallback rollout gate that stands in for
 *      customers on the ent-limited path who don't carry the billing entitlement yet.
 *
 * Single source of truth for the four consumers that must agree: the location-menu label toggle,
 * the global-menu item visibility, the location `communications.alerts` controller (choose iframe
 * vs. RRC), and the global `location-overview.communications.threat-dashboard` route (allow vs.
 * redirect). See `helpers/threat-intel-v2-enabled.ts` for the template-side wrapper.
 */
export function hasThreatIntelV2Access(featureFlags: FeatureFlagsService, state: StateService): boolean {
  const v2RolloutSplit = featureFlags.isEnabled('emno-threat-intelligence-web-v2');
  const billingEntitlement = isBillingFeatureEnabled('threat_dashboard', state);
  const entLimitedSplit = featureFlags.isEnabled('emno-threat-intelligence-vr-ent-limited');
  return v2RolloutSplit && (billingEntitlement || entLimitedSplit);
}
